const BaseURLStaging = process.env.VUE_APP_URL_API_STAGING;
const BaseURLProduct = process.env.VUE_APP_URL_API_PRODUCT;
const BaseURLDev = process.env.VUE_APP_URL_API_DEV;

const node = process.env.VUE_APP_NOTE;

const BaseURL = node == 'PRODUCT' ? BaseURLProduct : node == 'STAGING' ? BaseURLStaging : BaseURLDev;
// userPoolId
const userPoolIdAdminLocal = process.env.VUE_APP_COGNITO_USERPOOL_ID_LOCAL;
const userPoolIdAdminDEV = process.env.VUE_APP_COGNITO_USERPOOL_ID_DEV;
const userPoolIdAdminStaging = process.env.VUE_APP_COGNITO_USERPOOL_ID_STAGING;
const userPoolIdAdminProduct = process.env.VUE_APP_COGNITO_USERPOOL_ID_PRODUCT;

const userPoolIdAdmin =
  node == 'PRODUCT'
    ? userPoolIdAdminProduct
    : node == 'STAGING'
    ? userPoolIdAdminStaging
    : node == 'DEV'
    ? userPoolIdAdminDEV
    : userPoolIdAdminLocal;

// Client id
const clientIdAdminLocal = process.env.VUE_APP_COGNITO_CLIENT_ID_LOCAL;
const clientIdAdminDEV = process.env.VUE_APP_COGNITO_CLIENT_ID_DEV;
const clientIdAdminStaging = process.env.VUE_APP_COGNITO_CLIENT_ID_STAGING;
const clientIdAdminProduct = process.env.VUE_APP_COGNITO_CLIENT_ID_PRODUCT;

const clientIdAdmin =
  node == 'PRODUCT'
    ? clientIdAdminProduct
    : node == 'STAGING'
    ? clientIdAdminStaging
    : node == 'DEV'
    ? clientIdAdminDEV
    : clientIdAdminLocal;

// redirect SSO
const redirectLocal = process.env.VUE_APP_COGNITO_REDIRECT_URI_LOCAL;
const redirectDEV = process.env.VUE_APP_COGNITO_REDIRECT_URI_DEV;
const redirectStaging = process.env.VUE_APP_COGNITO_REDIRECT_URI_STAGING;
const redirectProduct = process.env.VUE_APP_COGNITO_REDIRECT_URI_PRODUCT;
const redirect =
  node == 'PRODUCT'
    ? redirectProduct
    : node == 'STAGING'
    ? redirectStaging
    : node == 'DEV'
    ? redirectDEV
    : redirectLocal;

// App domain
const appDomainLocal = process.env.VUE_APP_COGNITO_APP_DOMAIN_LOCAL;
const appDomainDEV = process.env.VUE_APP_COGNITO_APP_DOMAIN_DEV;
const appDomainStaging = process.env.VUE_APP_COGNITO_APP_DOMAIN_STAGING;
const appDomainProduct = process.env.VUE_APP_COGNITO_APP_DOMAIN_PRODUCT;
const appDomain =
  node == 'PRODUCT'
    ? appDomainProduct
    : node == 'STAGING'
    ? appDomainStaging
    : node == 'DEV'
    ? appDomainDEV
    : appDomainLocal;

// Redirect sigout
const redirectSigoutLocal = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT_LOCAL;
const redirectSigoutDEV = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT_DEV;
const redirectSigoutStaging = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT_STAGING;
const redirectSigoutProduct = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT_PRODUCT;
const redirectSigout =
  node == 'PRODUCT'
    ? redirectSigoutProduct
    : node == 'STAGING'
    ? redirectSigoutStaging
    : node == 'DEV'
    ? redirectSigoutDEV
    : redirectSigoutLocal;

const REGION =
  process.env.VUE_APP_NOTE == 'PRODUCT'
    ? process.env.VUE_APP_AWS_REGION_PRODUCT
    : process.env.VUE_APP_NOTE == 'STAGING'
    ? process.env.VUE_APP_AWS_REGION_STAGING
    : process.env.VUE_APP_AWS_REGION_DEV;

const IDENTITY_POOL_ID = process.env.VUE_APP_AWS_IDENTITY_POOL_ID;

export { BaseURL, userPoolIdAdmin, clientIdAdmin, appDomain, redirect, redirectSigout, REGION, IDENTITY_POOL_ID };
